import { Heading, ListItem, UnorderedList, VStack } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';
import { InternalTextLink } from '@oaknorth/util-routing';

import { useInternalFeatures } from './features-hooks';
import { HomePageCard, HomePageCardType } from './HomePageCard';
import { InternalFeatureSpec } from './types';

function InternalFeature({ name, to, subfeatures }: InternalFeatureSpec) {
  if (to !== undefined) {
    return <InternalTextLink to={to}>{name}</InternalTextLink>;
  }
  return (
    <VStack alignItems="flex-start">
      <Heading as="h4" paddingTop={2} fontWeight="normal" fontSize="xl">
        {name}
      </Heading>
      <UnorderedList>
        {subfeatures.map((subfeature) => {
          return (
            <ListItem key={subfeature.key}>
              <InternalFeature {...subfeature}></InternalFeature>
            </ListItem>
          );
        })}
      </UnorderedList>
    </VStack>
  );
}

export function InternalFeatures() {
  const internalFeatures = useInternalFeatures();
  if (internalFeatures === null) {
    return null;
  }
  return (
    <HomePageCard type={HomePageCardType.FULL}>
      <VStack padding={8} alignItems="flex-start" width="full" data-testid="home-page-internal-features" gap={0}>
        <Heading as="h3" paddingBottom={2} fontSize="2xl">{T`homePage.internalFeatures.heading`}</Heading>
        {internalFeatures.map(({ key, ...rest }) => {
          return <InternalFeature key={key} {...rest} />;
        })}
      </VStack>
    </HomePageCard>
  );
}
